/* zz-home.js — intentionally no-op. The scroll-reveal was removed 2026-07-20.
   Also strips any leftover reveal classes/inline styles from cached page states. */
(function () {
  try {
    document.querySelectorAll('.zz-reveal').forEach(function (el) {
      el.classList.remove('zz-reveal', 'zz-in');
      el.style.removeProperty('--zz-rd');
      el.style.removeProperty('opacity');
      el.style.removeProperty('transform');
    });
  } catch (e) {}
})();
